import React, { useState, useEffect, useRef } from 'react';
import html2canvas from 'html2canvas';
import { useLanguage } from '../contexts/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL;

const TEMPLATE_TYPES = [
  { value: 'general', label: 'General Newsletter', labelHi: 'सामान्य Newsletter', icon: '📰' },
  { value: 'admission', label: 'Admission Alert', labelHi: 'Admission अलर्ट', icon: '🎓' },
  { value: 'event', label: 'School Event', labelHi: 'School Event', icon: '🎉' },
  { value: 'exam_result', label: 'Exam Results', labelHi: 'Exam Results', icon: '📊' },
  { value: 'annual_day', label: 'Annual Day', labelHi: 'Annual Day', icon: '🏆' },
];

const TONES = [
  { value: 'professional', label: 'Professional', labelHi: 'पेशेवर' },
  { value: 'friendly', label: 'Friendly & Warm', labelHi: 'मित्रवत व गर्मजोशी' },
  { value: 'urgent', label: 'Urgent', labelHi: 'तत्काल' },
  { value: 'celebratory', label: 'Celebratory', labelHi: 'उत्सवपूर्ण' },
];

const T = {
  page_title: { en: 'AI Newsletter Generator', hi: 'AI न्यूज़लेटर जेनरेटर' },
  page_sub: { en: 'GPT-5.2 powered newsletters for your school', hi: 'आपके स्कूल के लिए GPT-5.2 आधारित न्यूज़लेटर' },
  tab_create: { en: 'Create', hi: 'बनाएं' },
  tab_editor: { en: 'Editor', hi: 'एडिटर' },
  tab_analytics: { en: 'Analytics', hi: 'एनालिटिक्स' },
  tab_scheduled: { en: 'Scheduled', hi: 'शेड्यूल्ड' },
  tab_history: { en: 'History', hi: 'इतिहास' },
  tab_subscribers: { en: 'Subscribers', hi: 'सब्सक्राइबर' },
  gen_title: { en: 'Generate Newsletter with AI', hi: 'AI से न्यूज़लेटर बनाएं' },
  topic: { en: 'Topic / Subject', hi: 'विषय / Subject' },
  topic_ph: { en: 'e.g. Annual Day 2025 celebration highlights', hi: 'जैसे: वार्षिकोत्सव 2025 की मुख्य झलकियाँ' },
  school_name: { en: 'School Name', hi: 'स्कूल का नाम' },
  school_ph: { en: 'e.g. Delhi Public Academy', hi: 'जैसे: दिल्ली पब्लिक एकेडमी' },
  template_type: { en: 'Template Type', hi: 'टेम्पलेट प्रकार' },
  tone: { en: 'Tone', hi: 'लहज़ा' },
  bilingual: { en: 'Hindi + English (Bilingual)', hi: 'हिंदी + English (द्विभाषी)' },
  generating: { en: 'Generating...', hi: 'बन रहा है...' },
  gen_btn: { en: '✨ Generate Newsletter', hi: '✨ न्यूज़लेटर बनाएं' },
  nl_title_ph: { en: 'Newsletter Title', hi: 'न्यूज़लेटर शीर्षक' },
  preview_mode: { en: '👁 Preview', hi: '👁 प्रीव्यू' },
  edit_html: { en: '✏️ Edit HTML', hi: '✏️ HTML एडिट करें' },
  save: { en: '💾 Save', hi: '💾 सेव' },
  export_html: { en: '📤 Export HTML', hi: '📤 HTML एक्सपोर्ट' },
  download_img: { en: '🖼 Download Image', hi: '🖼 इमेज डाउनलोड' },
  preview_of: { en: 'Preview — ', hi: 'प्रीव्यू — ' },
  send_nl: { en: 'Send Newsletter', hi: 'न्यूज़लेटर भेजें' },
  send_now: { en: 'Send Now', hi: 'अभी भेजें' },
  schedule: { en: 'Schedule', hi: 'शेड्यूल' },
  subject: { en: 'Subject', hi: 'Subject' },
  recipients: { en: 'Recipients (comma-separated emails)', hi: 'प्राप्तकर्ता (comma से अलग emails)' },
  recipients_ph: { en: 'parent1@email.com, parent2@email.com', hi: 'parent1@email.com, parent2@email.com' },
  date: { en: 'Date', hi: 'तारीख़' },
  time: { en: 'Time', hi: 'समय' },
  will_send_on: { en: 'Newsletter will be sent on ', hi: 'न्यूज़लेटर भेजा जाएगा ' },
  load_all: { en: 'Load all', hi: 'सभी लोड करें' },
  subscribers_word: { en: 'subscribers', hi: 'सब्सक्राइबर' },
  sending: { en: 'Sending...', hi: 'भेजा जा रहा है...' },
  scheduling: { en: 'Scheduling...', hi: 'शेड्यूल हो रहा...' },
  schedule_send: { en: 'Schedule Send', hi: 'शेड्यूल करें' },
  no_editor: { en: 'No newsletter in editor. Go to Create tab to generate one.', hi: 'एडिटर में कोई न्यूज़लेटर नहीं। बनाने के लिए Create टैब पर जाएं।' },
  create_new: { en: '✨ Create New', hi: '✨ नया बनाएं' },
  nl_analytics: { en: 'Newsletter Analytics', hi: 'न्यूज़लेटर एनालिटिक्स' },
  analytics_sub: { en: 'Email delivery, open rates & click tracking', hi: 'ईमेल डिलीवरी, open rate व click tracking' },
  refresh: { en: 'Refresh', hi: 'रिफ्रेश' },
  st_total_sent: { en: 'Total Sent', hi: 'कुल भेजे' },
  st_delivered: { en: 'Delivered', hi: 'डिलीवर हुए' },
  st_opened: { en: 'Opened', hi: 'खोले गए' },
  st_open_rate: { en: 'Open Rate', hi: 'Open Rate' },
  st_clicks: { en: 'Clicks', hi: 'क्लिक्स' },
  st_failed: { en: 'Failed', hi: 'विफल' },
  nl_performance: { en: 'Newsletter Performance', hi: 'न्यूज़लेटर प्रदर्शन' },
  c_newsletter: { en: 'Newsletter', hi: 'न्यूज़लेटर' },
  c_sent: { en: 'Sent', hi: 'भेजे' },
  c_opened: { en: 'Opened', hi: 'खोले' },
  c_open_rate: { en: 'Open Rate', hi: 'Open Rate' },
  c_clicked: { en: 'Clicked', hi: 'क्लिक' },
  c_failed: { en: 'Failed', hi: 'विफल' },
  c_action: { en: 'Action', hi: 'कार्रवाई' },
  details: { en: 'Details', hi: 'विवरण' },
  untitled: { en: 'Untitled', hi: 'बिना शीर्षक' },
  sent_label: { en: 'Sent:', hi: 'भेजा:' },
  status_label: { en: 'Status:', hi: 'स्थिति:' },
  recipient_status: { en: 'Recipient Status', hi: 'प्राप्तकर्ता स्थिति' },
  not_opened: { en: 'Not Opened', hi: 'नहीं खोला' },
  clicks_word: { en: 'clicks', hi: 'क्लिक' },
  no_analytics: { en: 'No analytics data yet', hi: 'अभी कोई एनालिटिक्स डेटा नहीं' },
  no_analytics_sub: { en: 'Tracking data will appear here after you send a newsletter', hi: 'न्यूज़लेटर भेजने के बाद यहाँ tracking data दिखेगा' },
  scheduled_nl: { en: 'Scheduled Newsletters', hi: 'शेड्यूल किए न्यूज़लेटर' },
  upcoming: { en: 'Upcoming', hi: 'आगामी' },
  remaining: { en: 'remaining', hi: 'बाकी' },
  recipients_word: { en: 'recipients', hi: 'प्राप्तकर्ता' },
  cancel: { en: 'Cancel', hi: 'रद्द करें' },
  past_schedules: { en: 'Past Schedules', hi: 'पिछले शेड्यूल' },
  cancelled: { en: 'Cancelled', hi: 'रद्द' },
  error_word: { en: 'Error', hi: 'त्रुटि' },
  due_now: { en: 'Due now', hi: 'अभी देय' },
  days: { en: 'days', hi: 'दिन' },
  no_scheduled: { en: 'No scheduled newsletters', hi: 'कोई शेड्यूल्ड न्यूज़लेटर नहीं' },
  no_scheduled_sub: { en: 'Create a newsletter in the Editor tab and select "Schedule" mode', hi: 'Editor टैब में न्यूज़लेटर बनाएं और "Schedule" mode चुनें' },
  create_nl: { en: 'Create Newsletter', hi: 'न्यूज़लेटर बनाएं' },
  saved_nl: { en: 'Saved Newsletters', hi: 'सेव किए न्यूज़लेटर' },
  no_nl: { en: 'No newsletters yet', hi: 'अभी कोई न्यूज़लेटर नहीं' },
  draft: { en: '📝 Draft', hi: '📝 ड्राफ्ट' },
  open: { en: 'Open', hi: 'खोलें' },
  add_subscriber: { en: 'Add Subscriber', hi: 'सब्सक्राइबर जोड़ें' },
  name: { en: 'Name', hi: 'नाम' },
  email: { en: 'Email', hi: 'ईमेल' },
  cat_parent: { en: 'Parent', hi: 'अभिभावक' },
  cat_teacher: { en: 'Teacher', hi: 'शिक्षक' },
  cat_admin: { en: 'Admin', hi: 'एडमिन' },
  cat_student: { en: 'Student', hi: 'विद्यार्थी' },
  add: { en: '+ Add', hi: '+ जोड़ें' },
  no_subs: { en: 'No subscribers yet', hi: 'अभी कोई सब्सक्राइबर नहीं' },
  confirm_cancel_sched: { en: 'Cancel this schedule?', hi: 'यह शेड्यूल रद्द करें?' },
};

export default function NewsletterManager({ token }) {
  const { language } = useLanguage();
  const tr = (k) => (T[k] ? T[k][language] || T[k].en : k);
  const locale = language === 'hi' ? 'hi-IN' : 'en-IN';
  const [tab, setTab] = useState('create');
  const [newsletters, setNewsletters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [sending, setSending] = useState(false);
  const [subscribers, setSubscribers] = useState([]);
  const [sendResult, setSendResult] = useState(null);

  // Create form
  const [topic, setTopic] = useState('');
  const [templateType, setTemplateType] = useState('general');
  const [tone, setTone] = useState('professional');
  const [schoolName, setSchoolName] = useState('');
  const [includeHindi, setIncludeHindi] = useState(true);

  // Editor
  const [htmlContent, setHtmlContent] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [currentTitle, setCurrentTitle] = useState('');
  const [currentId, setCurrentId] = useState(null);
  const previewRef = useRef(null);

  // Subscriber form
  const [newSubEmail, setNewSubEmail] = useState('');
  const [newSubName, setNewSubName] = useState('');
  const [newSubCategory, setNewSubCategory] = useState('parent');

  // Send form
  const [sendEmails, setSendEmails] = useState('');
  const [sendSubject, setSendSubject] = useState('');

  // Analytics state
  const [analyticsData, setAnalyticsData] = useState(null);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [selectedNlAnalytics, setSelectedNlAnalytics] = useState(null);
  const [scheduleDate, setScheduleDate] = useState('');
  const [scheduleTime, setScheduleTime] = useState('');
  const [scheduleMode, setScheduleMode] = useState(false);
  const [scheduling, setScheduling] = useState(false);
  const [scheduledList, setScheduledList] = useState([]);

  const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  useEffect(() => { fetchNewsletters(); fetchSubscribers(); fetchScheduled(); }, []);

  const fetchNewsletters = async () => {
    try {
      const res = await fetch(`${API}/api/newsletter/list`, { headers });
      const data = await res.json();
      if (data.success) setNewsletters(data.newsletters);
    } catch (e) { console.error(e); }
  };

  const fetchSubscribers = async () => {
    try {
      const res = await fetch(`${API}/api/newsletter/subscribers/list`, { headers });
      const data = await res.json();
      if (data.success) setSubscribers(data.subscribers);
    } catch (e) { console.error(e); }
  };

  const generateNewsletter = async () => {
    if (!topic.trim()) return;
    setGenerating(true);
    try {
      const res = await fetch(`${API}/api/newsletter/generate`, {
        method: 'POST', headers,
        body: JSON.stringify({ topic, template_type: templateType, tone, school_name: schoolName, include_hindi: includeHindi }),
      });
      const data = await res.json();
      if (data.success) {
        setHtmlContent(data.html_content);
        setCurrentTitle(data.title);
        setCurrentId(data.newsletter_id);
        setTab('editor');
        fetchNewsletters();
      }
    } catch (e) { console.error(e); }
    setGenerating(false);
  };

  const saveNewsletter = async () => {
    setLoading(true);
    try {
      await fetch(`${API}/api/newsletter/save`, {
        method: 'POST', headers,
        body: JSON.stringify({ title: currentTitle, html_content: htmlContent, template_type: templateType }),
      });
      fetchNewsletters();
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const loadNewsletter = async (id) => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/newsletter/get/${id}`, { headers });
      const data = await res.json();
      if (data.success) {
        setHtmlContent(data.newsletter.html_content);
        setCurrentTitle(data.newsletter.title);
        setCurrentId(id);
        setTab('editor');
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const deleteNewsletter = async (id) => {
    try {
      await fetch(`${API}/api/newsletter/delete/${id}`, { method: 'DELETE', headers });
      fetchNewsletters();
    } catch (e) { console.error(e); }
  };

  const sendNewsletter = async () => {
    if (!currentId || !sendEmails.trim()) return;
    setSending(true); setSendResult(null);
    const recipients = sendEmails.split(',').map(e => e.trim()).filter(Boolean);
    try {
      const res = await fetch(`${API}/api/newsletter/send`, {
        method: 'POST', headers,
        body: JSON.stringify({ newsletter_id: currentId, recipients, subject: sendSubject || currentTitle }),
      });
      const data = await res.json();
      setSendResult(data);
      if (data.success) fetchNewsletters();
    } catch (e) { setSendResult({ success: false, detail: 'Network error' }); }
    setSending(false);
  };

  const addSubscriber = async () => {
    if (!newSubEmail.trim()) return;
    try {
      await fetch(`${API}/api/newsletter/subscribers/add`, {
        method: 'POST', headers,
        body: JSON.stringify({ email: newSubEmail, name: newSubName, category: newSubCategory }),
      });
      fetchSubscribers();
      setNewSubEmail(''); setNewSubName('');
    } catch (e) { console.error(e); }
  };

  const fetchScheduled = async () => {
    try {
      const res = await fetch(`${API}/api/newsletter/scheduled`, { headers });
      const data = await res.json();
      if (data.success) setScheduledList(data.scheduled || []);
    } catch (e) { console.error(e); }
  };

  const scheduleNewsletter = async () => {
    if (!currentId || !sendEmails.trim() || !scheduleDate || !scheduleTime) return;
    setScheduling(true); setSendResult(null);
    const recipients = sendEmails.split(',').map(e => e.trim()).filter(Boolean);
    const scheduledAt = new Date(`${scheduleDate}T${scheduleTime}`).toISOString();
    try {
      const res = await fetch(`${API}/api/newsletter/schedule`, {
        method: 'POST', headers,
        body: JSON.stringify({ newsletter_id: currentId, recipients, subject: sendSubject || currentTitle, scheduled_at: scheduledAt }),
      });
      const data = await res.json();
      setSendResult(data);
      if (data.success) { fetchNewsletters(); fetchScheduled(); setScheduleMode(false); }
    } catch (e) { setSendResult({ success: false, detail: 'Network error' }); }
    setScheduling(false);
  };

  const cancelSchedule = async (scheduleId) => {
    if (!window.confirm(tr('confirm_cancel_sched'))) return;
    try {
      const res = await fetch(`${API}/api/newsletter/cancel-schedule/${scheduleId}`, { method: 'POST', headers });
      const data = await res.json();
      if (data.success) { fetchScheduled(); fetchNewsletters(); }
    } catch (e) { console.error(e); }
  };

  const loadAnalytics = async () => {
    setAnalyticsLoading(true);
    try {
      const res = await fetch(`${API}/api/newsletter/analytics-overview`, { headers });
      const data = await res.json();
      if (data.success) setAnalyticsData(data);
    } catch (e) { console.error(e); }
    setAnalyticsLoading(false);
  };

  const loadNlAnalytics = async (nlId) => {
    try {
      const res = await fetch(`${API}/api/newsletter/analytics/${nlId}`, { headers });
      const data = await res.json();
      if (data.success) setSelectedNlAnalytics(data);
    } catch (e) { console.error(e); }
  };

  const downloadAsImage = async () => {
    if (!previewRef.current) return;
    const canvas = await html2canvas(previewRef.current, { scale: 2, useCORS: true });
    const link = document.createElement('a');
    link.download = `newsletter-${Date.now()}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  const exportHTML = () => {
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = `newsletter-${Date.now()}.html`;
    link.href = url;
    link.click();
    URL.revokeObjectURL(url);
  };

  const scheduledCount = scheduledList.filter(s => s.status === 'scheduled').length;

  return (
    <div className="space-y-6" data-testid="newsletter-manager">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900" style={{fontFamily:'Outfit'}}>{tr('page_title')}</h1>
          <p className="text-slate-500 text-sm" style={{fontFamily:'Manrope'}}>{tr('page_sub')}</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 bg-slate-100 p-1 rounded-xl w-fit" data-testid="newsletter-tabs">
        {[
          { id: 'create', label: tr('tab_create'), icon: '✨' },
          { id: 'editor', label: tr('tab_editor'), icon: '📝' },
          { id: 'analytics', label: tr('tab_analytics'), icon: '📊' },
          { id: 'scheduled', label: `${tr('tab_scheduled')}${scheduledCount > 0 ? ` (${scheduledCount})` : ''}`, icon: '⏰' },
          { id: 'history', label: tr('tab_history'), icon: '📋' },
          { id: 'subscribers', label: tr('tab_subscribers'), icon: '👥' },
        ].map(t => (
          <button key={t.id} onClick={() => { setTab(t.id); if (t.id === 'analytics') loadAnalytics(); }}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition ${tab === t.id ? 'bg-white shadow text-orange-600' : 'text-slate-500 hover:text-slate-700'}`}
            data-testid={`tab-${t.id}`}
          >{t.icon} {t.label}</button>
        ))}
      </div>

      {/* CREATE TAB */}
      {tab === 'create' && (
        <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-testid="create-tab">
          <h2 className="text-lg font-bold text-slate-900 mb-4" style={{fontFamily:'Outfit'}}>{tr('gen_title')}</h2>

          <div className="grid md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1 block">{tr('topic')}</label>
              <input value={topic} onChange={e => setTopic(e.target.value)} placeholder={tr('topic_ph')}
                className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:border-orange-500 transition" data-testid="input-topic" />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1 block">{tr('school_name')}</label>
              <input value={schoolName} onChange={e => setSchoolName(e.target.value)} placeholder={tr('school_ph')}
                className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:border-orange-500 transition" data-testid="input-school" />
            </div>
          </div>

          {/* Template Types */}
          <label className="text-sm font-medium text-slate-700 mb-2 block">{tr('template_type')}</label>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-2 mb-4" data-testid="template-types">
            {TEMPLATE_TYPES.map(t => (
              <button key={t.value} onClick={() => setTemplateType(t.value)}
                className={`p-3 rounded-xl border text-center transition ${templateType === t.value ? 'border-orange-500 bg-orange-50 text-orange-700' : 'border-slate-200 hover:border-orange-300'}`}
                data-testid={`template-${t.value}`}
              >
                <span className="text-2xl block mb-1">{t.icon}</span>
                <span className="text-xs font-medium">{language === 'hi' ? t.labelHi : t.label}</span>
              </button>
            ))}
          </div>

          {/* Tone + Hindi */}
          <div className="flex flex-wrap gap-4 mb-6">
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1 block">{tr('tone')}</label>
              <select value={tone} onChange={e => setTone(e.target.value)} className="border border-slate-300 rounded-xl px-4 py-2.5 focus:outline-none focus:border-orange-500" data-testid="select-tone">
                {TONES.map(t => <option key={t.value} value={t.value}>{language === 'hi' ? t.labelHi : t.label}</option>)}
              </select>
            </div>
            <div className="flex items-end">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" checked={includeHindi} onChange={e => setIncludeHindi(e.target.checked)} className="w-4 h-4 accent-orange-500" data-testid="toggle-hindi" />
                <span className="text-sm font-medium text-slate-700">{tr('bilingual')}</span>
              </label>
            </div>
          </div>

          <button onClick={generateNewsletter} disabled={generating || !topic.trim()}
            className="px-6 py-3 bg-orange-500 text-white rounded-xl font-bold hover:bg-orange-600 transition disabled:opacity-50 flex items-center gap-2"
            data-testid="btn-generate"
          >
            {generating ? (
              <><svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg> {tr('generating')}</>
            ) : tr('gen_btn')}
          </button>
        </div>
      )}

      {/* EDITOR TAB */}
      {tab === 'editor' && (
        <div data-testid="editor-tab">
          {htmlContent ? (
            <div className="space-y-4">
              {/* Toolbar */}
              <div className="bg-white rounded-2xl border border-slate-200 p-4 shadow-sm flex flex-wrap items-center gap-3">
                <input value={currentTitle} onChange={e => setCurrentTitle(e.target.value)} className="flex-1 min-w-[200px] border border-slate-300 rounded-lg px-3 py-2 text-sm font-bold focus:outline-none focus:border-orange-500" placeholder={tr('nl_title_ph')} data-testid="input-title" />
                <button onClick={() => setEditMode(!editMode)} className={`px-4 py-2 rounded-lg text-sm font-medium transition ${editMode ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`} data-testid="btn-edit-mode">
                  {editMode ? tr('preview_mode') : tr('edit_html')}
                </button>
                <button onClick={saveNewsletter} className="px-4 py-2 bg-green-500 text-white rounded-lg text-sm font-medium hover:bg-green-600 transition" data-testid="btn-save">{tr('save')}</button>
                <button onClick={exportHTML} className="px-4 py-2 bg-slate-700 text-white rounded-lg text-sm font-medium hover:bg-slate-800 transition" data-testid="btn-export">{tr('export_html')}</button>
                <button onClick={downloadAsImage} className="px-4 py-2 bg-purple-500 text-white rounded-lg text-sm font-medium hover:bg-purple-600 transition" data-testid="btn-download-img">{tr('download_img')}</button>
              </div>

              {/* Editor/Preview */}
              {editMode ? (
                <textarea value={htmlContent} onChange={e => setHtmlContent(e.target.value)}
                  className="w-full h-[600px] bg-slate-900 text-green-400 font-mono text-sm p-4 rounded-2xl border border-slate-700 focus:outline-none focus:border-orange-500"
                  data-testid="html-editor" />
              ) : (
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                  <div className="bg-slate-100 px-4 py-2 text-xs text-slate-500 border-b">{tr('preview_of')}{currentTitle}</div>
                  <div ref={previewRef} className="p-4" data-testid="html-preview">
                    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                  </div>
                </div>
              )}

              {/* Send / Schedule Section */}
              <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-testid="send-section">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-bold text-slate-900" style={{fontFamily:'Outfit'}}>{tr('send_nl')}</h3>
                  <div className="flex bg-slate-100 p-1 rounded-lg">
                    <button onClick={() => setScheduleMode(false)}
                      className={`px-4 py-1.5 rounded-md text-sm font-medium transition ${!scheduleMode ? 'bg-white shadow text-orange-600' : 'text-slate-500'}`}
                      data-testid="btn-send-mode">
                      {tr('send_now')}
                    </button>
                    <button onClick={() => setScheduleMode(true)}
                      className={`px-4 py-1.5 rounded-md text-sm font-medium transition ${scheduleMode ? 'bg-white shadow text-orange-600' : 'text-slate-500'}`}
                      data-testid="btn-schedule-mode">
                      {tr('schedule')}
                    </button>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="text-sm font-medium text-slate-700 mb-1 block">{tr('subject')}</label>
                    <input value={sendSubject} onChange={e => setSendSubject(e.target.value)} placeholder={currentTitle}
                      className="w-full border border-slate-300 rounded-xl px-4 py-2.5 focus:outline-none focus:border-orange-500" data-testid="input-subject" />
                  </div>
                  <div>
                    <label className="text-sm font-medium text-slate-700 mb-1 block">{tr('recipients')}</label>
                    <input value={sendEmails} onChange={e => setSendEmails(e.target.value)} placeholder={tr('recipients_ph')}
                      className="w-full border border-slate-300 rounded-xl px-4 py-2.5 focus:outline-none focus:border-orange-500" data-testid="input-recipients" />
                  </div>
                </div>

                {/* Schedule date/time picker */}
                {scheduleMode && (
                  <div className="grid md:grid-cols-2 gap-4 mb-4 p-4 bg-orange-50 rounded-xl border border-orange-200" data-testid="schedule-picker">
                    <div>
                      <label className="text-sm font-medium text-orange-700 mb-1 block">{tr('date')}</label>
                      <input type="date" value={scheduleDate} onChange={e => setScheduleDate(e.target.value)}
                        min={new Date().toISOString().split('T')[0]}
                        className="w-full border border-orange-300 rounded-xl px-4 py-2.5 focus:outline-none focus:border-orange-500 bg-white" data-testid="input-schedule-date" />
                    </div>
                    <div>
                      <label className="text-sm font-medium text-orange-700 mb-1 block">{tr('time')}</label>
                      <input type="time" value={scheduleTime} onChange={e => setScheduleTime(e.target.value)}
                        className="w-full border border-orange-300 rounded-xl px-4 py-2.5 focus:outline-none focus:border-orange-500 bg-white" data-testid="input-schedule-time" />
                    </div>
                    {scheduleDate && scheduleTime && (
                      <div className="md:col-span-2 text-sm text-orange-700 bg-orange-100 rounded-lg px-3 py-2">
                        {tr('will_send_on')}<strong>{new Date(`${scheduleDate}T${scheduleTime}`).toLocaleString(locale, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</strong>
                      </div>
                    )}
                  </div>
                )}

                {subscribers.length > 0 && (
                  <button onClick={() => setSendEmails(subscribers.map(s => s.email).join(', '))}
                    className="text-sm text-orange-500 hover:text-orange-600 underline mb-3 block" data-testid="btn-load-subs">
                    {tr('load_all')} {subscribers.length} {tr('subscribers_word')}
                  </button>
                )}

                <div className="flex items-center gap-3">
                  {!scheduleMode ? (
                    <button onClick={sendNewsletter} disabled={sending || !currentId}
                      className="px-6 py-3 bg-orange-500 text-white rounded-xl font-bold hover:bg-orange-600 transition disabled:opacity-50 flex items-center gap-2"
                      data-testid="btn-send"
                    >{sending ? tr('sending') : tr('send_now')}</button>
                  ) : (
                    <button onClick={scheduleNewsletter} disabled={scheduling || !currentId || !scheduleDate || !scheduleTime}
                      className="px-6 py-3 bg-gradient-to-r from-orange-500 to-amber-500 text-white rounded-xl font-bold hover:from-orange-600 hover:to-amber-600 transition disabled:opacity-50 flex items-center gap-2"
                      data-testid="btn-schedule"
                    >{scheduling ? tr('scheduling') : tr('schedule_send')}</button>
                  )}
                </div>
                {sendResult && (
                  <div className={`mt-3 p-3 rounded-xl text-sm ${sendResult.success ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`} data-testid="send-result">
                    {sendResult.success ? (sendResult.schedule_id ? `${tr('schedule')} — ${new Date(sendResult.scheduled_at).toLocaleString(locale)} — ${sendResult.recipients_count} ${tr('recipients_word')}` : `${tr('st_delivered')}: ${sendResult.sent} ${tr('recipients_word')}${sendResult.failed?.length ? `, ${sendResult.failed.length} ${tr('st_failed')}` : ''}`) : `${sendResult.detail || tr('st_failed')}`}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-2xl border border-slate-200 p-12 text-center shadow-sm">
              <span className="text-5xl block mb-3">📝</span>
              <p className="text-slate-500" style={{fontFamily:'Manrope'}}>{tr('no_editor')}</p>
              <button onClick={() => setTab('create')} className="mt-4 px-4 py-2 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition">{tr('create_new')}</button>
            </div>
          )}
        </div>
      )}

      {/* ANALYTICS TAB */}
      {tab === 'analytics' && (
        <div className="space-y-6" data-testid="analytics-tab">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-bold text-slate-900" style={{fontFamily:'Outfit'}}>{tr('nl_analytics')}</h2>
              <p className="text-sm text-gray-500">{tr('analytics_sub')}</p>
            </div>
            <button onClick={loadAnalytics} disabled={analyticsLoading} className="px-4 py-2 bg-slate-100 text-slate-700 rounded-lg text-sm hover:bg-slate-200" data-testid="btn-refresh-analytics">
              {analyticsLoading ? '...' : tr('refresh')}
            </button>
          </div>

          {/* Overview Stats */}
          {analyticsData?.stats && (
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {[
                { label: tr('st_total_sent'), value: analyticsData.stats.total_sent, color: 'border-blue-200', text: 'text-blue-700', bg: 'bg-blue-50' },
                { label: tr('st_delivered'), value: analyticsData.stats.total_sent - analyticsData.stats.total_failed, color: 'border-green-200', text: 'text-green-700', bg: 'bg-green-50' },
                { label: tr('st_opened'), value: analyticsData.stats.total_opened, color: 'border-orange-200', text: 'text-orange-700', bg: 'bg-orange-50' },
                { label: tr('st_open_rate'), value: `${analyticsData.stats.open_rate}%`, color: 'border-purple-200', text: 'text-purple-700', bg: 'bg-purple-50' },
                { label: tr('st_clicks'), value: analyticsData.stats.total_clicks, color: 'border-cyan-200', text: 'text-cyan-700', bg: 'bg-cyan-50' },
                { label: tr('st_failed'), value: analyticsData.stats.total_failed, color: 'border-red-200', text: 'text-red-700', bg: 'bg-red-50' },
              ].map((s, i) => (
                <div key={i} className={`bg-white rounded-xl p-4 border ${s.color} shadow-sm`} data-testid={`stat-${i}`}>
                  <p className="text-xs text-gray-500 uppercase tracking-wide">{s.label}</p>
                  <p className={`text-2xl font-bold mt-1 ${s.text}`}>{s.value}</p>
                </div>
              ))}
            </div>
          )}

          {/* Per-Newsletter Stats */}
          {analyticsData?.newsletter_stats?.length > 0 && (
            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
              <div className="p-4 border-b border-slate-100">
                <h3 className="font-bold text-slate-800">{tr('nl_performance')}</h3>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-sm" data-testid="newsletter-performance-table">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="text-left px-4 py-3 font-medium text-slate-600">{tr('c_newsletter')}</th>
                      <th className="text-center px-3 py-3 font-medium text-slate-600">{tr('c_sent')}</th>
                      <th className="text-center px-3 py-3 font-medium text-slate-600">{tr('c_opened')}</th>
                      <th className="text-center px-3 py-3 font-medium text-slate-600">{tr('c_open_rate')}</th>
                      <th className="text-center px-3 py-3 font-medium text-slate-600">{tr('c_clicked')}</th>
                      <th className="text-center px-3 py-3 font-medium text-slate-600">{tr('c_failed')}</th>
                      <th className="text-center px-3 py-3 font-medium text-slate-600">{tr('c_action')}</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {analyticsData.newsletter_stats.map((ns, i) => (
                      <tr key={ns.newsletter_id || i} className="hover:bg-slate-50 transition">
                        <td className="px-4 py-3">
                          <p className="font-medium text-slate-800 truncate max-w-[200px]">{ns.subject || tr('untitled')}</p>
                          <p className="text-xs text-gray-400">{ns.sent_at ? new Date(ns.sent_at).toLocaleString(locale) : ''}</p>
                        </td>
                        <td className="text-center px-3 py-3 font-semibold">{ns.total}</td>
                        <td className="text-center px-3 py-3">
                          <span className="text-green-600 font-semibold">{ns.opened}</span>
                        </td>
                        <td className="text-center px-3 py-3">
                          <div className="flex items-center justify-center gap-1">
                            <div className="w-12 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                              <div className="h-full bg-orange-500 rounded-full" style={{width: `${Math.min(ns.open_rate, 100)}%`}}></div>
                            </div>
                            <span className="text-xs font-medium text-slate-600">{ns.open_rate}%</span>
                          </div>
                        </td>
                        <td className="text-center px-3 py-3 text-cyan-600 font-semibold">{ns.clicked}</td>
                        <td className="text-center px-3 py-3">
                          {ns.failed > 0 ? <span className="text-red-600 font-semibold">{ns.failed}</span> : <span className="text-green-500">0</span>}
                        </td>
                        <td className="text-center px-3 py-3">
                          <button onClick={() => loadNlAnalytics(ns.newsletter_id)}
                            className="px-3 py-1 bg-orange-50 text-orange-600 rounded-lg text-xs font-medium hover:bg-orange-100 transition"
                            data-testid={`btn-detail-${i}`}>
                            {tr('details')}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Detailed Analytics for Selected Newsletter */}
          {selectedNlAnalytics && (
            <div className="bg-white rounded-2xl border border-orange-200 shadow-sm p-5" data-testid="newsletter-detail-analytics">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="font-bold text-slate-900">{selectedNlAnalytics.newsletter?.title || selectedNlAnalytics.newsletter?.subject}</h3>
                  <p className="text-sm text-gray-500">
                    {tr('sent_label')} {selectedNlAnalytics.newsletter?.sent_at ? new Date(selectedNlAnalytics.newsletter.sent_at).toLocaleString(locale) : 'N/A'} |
                    {' '}{tr('status_label')} <span className={selectedNlAnalytics.newsletter?.status === 'sent' ? 'text-green-600' : 'text-orange-600'}>{selectedNlAnalytics.newsletter?.status}</span>
                  </p>
                </div>
                <button onClick={() => setSelectedNlAnalytics(null)} className="text-gray-400 hover:text-gray-600 text-xl">&times;</button>
              </div>

              {/* Mini Stats */}
              <div className="grid grid-cols-4 gap-3 mb-4">
                <div className="bg-blue-50 rounded-lg p-3 text-center">
                  <p className="text-lg font-bold text-blue-700">{selectedNlAnalytics.stats?.total_sent}</p>
                  <p className="text-xs text-blue-600">{tr('c_sent')}</p>
                </div>
                <div className="bg-green-50 rounded-lg p-3 text-center">
                  <p className="text-lg font-bold text-green-700">{selectedNlAnalytics.stats?.total_opened}</p>
                  <p className="text-xs text-green-600">{tr('c_opened')}</p>
                </div>
                <div className="bg-orange-50 rounded-lg p-3 text-center">
                  <p className="text-lg font-bold text-orange-700">{selectedNlAnalytics.stats?.open_rate}%</p>
                  <p className="text-xs text-orange-600">{tr('st_open_rate')}</p>
                </div>
                <div className="bg-red-50 rounded-lg p-3 text-center">
                  <p className="text-lg font-bold text-red-700">{selectedNlAnalytics.stats?.total_failed}</p>
                  <p className="text-xs text-red-600">{tr('st_failed')}</p>
                </div>
              </div>

              {/* Recipient-level tracking */}
              <h4 className="font-semibold text-slate-700 mb-2 text-sm">{tr('recipient_status')}</h4>
              <div className="divide-y divide-slate-100 border border-slate-200 rounded-lg overflow-hidden">
                {selectedNlAnalytics.recipients?.map((r, i) => (
                  <div key={i} className="flex items-center justify-between px-4 py-2.5 hover:bg-slate-50" data-testid={`recipient-${i}`}>
                    <div className="flex items-center gap-3">
                      <span className={`w-2 h-2 rounded-full ${r.status === 'sent' ? (r.opened ? 'bg-green-500' : 'bg-blue-400') : 'bg-red-500'}`}></span>
                      <span className="text-sm font-medium text-slate-700">{r.email}</span>
                    </div>
                    <div className="flex items-center gap-3 text-xs">
                      <span className={`px-2 py-0.5 rounded-full ${r.status === 'sent' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        {r.status === 'sent' ? tr('st_delivered') : tr('st_failed')}
                      </span>
                      {r.opened ? (
                        <span className="px-2 py-0.5 rounded-full bg-orange-100 text-orange-700">
                          {tr('c_opened')} ({r.open_count}x)
                        </span>
                      ) : (
                        <span className="px-2 py-0.5 rounded-full bg-gray-100 text-gray-500">{tr('not_opened')}</span>
                      )}
                      {r.clicks > 0 && (
                        <span className="px-2 py-0.5 rounded-full bg-cyan-100 text-cyan-700">
                          {r.clicks} {tr('clicks_word')}
                        </span>
                      )}
                      {r.last_opened_at && (
                        <span className="text-gray-400">{new Date(r.last_opened_at).toLocaleString(locale, { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {(!analyticsData || (!analyticsData.newsletter_stats?.length && !analyticsData.stats?.total_sent)) && !analyticsLoading && (
            <div className="bg-white rounded-2xl border border-slate-200 p-12 text-center shadow-sm" data-testid="no-analytics">
              <span className="text-5xl block mb-3">📊</span>
              <p className="text-slate-500 font-medium">{tr('no_analytics')}</p>
              <p className="text-sm text-slate-400 mt-1">{tr('no_analytics_sub')}</p>
            </div>
          )}
        </div>
      )}

      {/* SCHEDULED TAB */}
      {tab === 'scheduled' && (
        <div className="space-y-4" data-testid="scheduled-tab">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-bold text-slate-900" style={{fontFamily:'Outfit'}}>{tr('scheduled_nl')}</h2>
            <button onClick={fetchScheduled} className="px-3 py-1.5 bg-slate-100 text-slate-600 rounded-lg text-sm hover:bg-slate-200" data-testid="btn-refresh-scheduled">{tr('refresh')}</button>
          </div>

          {/* Active Schedules */}
          {scheduledList.filter(s => s.status === 'scheduled').length > 0 && (
            <div className="space-y-3">
              <h3 className="text-sm font-semibold text-orange-600 uppercase tracking-wide">{tr('upcoming')}</h3>
              {scheduledList.filter(s => s.status === 'scheduled').map((s, i) => {
                const schedDate = new Date(s.scheduled_at);
                const now = new Date();
                const diffMs = schedDate - now;
                const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                const timeLeft = diffMs > 0 ? (diffHours > 24 ? `${Math.floor(diffHours/24)} ${tr('days')} ${diffHours%24}h` : diffHours > 0 ? `${diffHours}h ${diffMins}m` : `${diffMins}m`) : tr('due_now');

                return (
                  <div key={s.schedule_id || i} className="bg-white rounded-2xl border border-orange-200 p-5 shadow-sm" data-testid={`scheduled-item-${i}`}>
                    <div className="flex items-start justify-between">
                      <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-orange-100 rounded-xl flex flex-col items-center justify-center text-orange-700 shrink-0">
                          <span className="text-xs font-bold leading-none">{schedDate.toLocaleDateString('en', { month: 'short' })}</span>
                          <span className="text-lg font-bold leading-none">{schedDate.getDate()}</span>
                        </div>
                        <div>
                          <p className="font-bold text-slate-900">{s.newsletter_title || s.subject}</p>
                          <div className="flex items-center gap-3 text-xs text-slate-400 mt-1 flex-wrap">
                            <span>{schedDate.toLocaleString(locale, { weekday: 'long', hour: '2-digit', minute: '2-digit' })}</span>
                            <span className="px-2 py-0.5 bg-orange-100 text-orange-700 rounded-full font-medium">{timeLeft} {tr('remaining')}</span>
                            <span>{s.recipients?.length || 0} {tr('recipients_word')}</span>
                          </div>
                        </div>
                      </div>
                      <button onClick={() => cancelSchedule(s.schedule_id)}
                        className="px-4 py-2 bg-red-50 text-red-600 rounded-lg text-sm font-medium hover:bg-red-100 transition"
                        data-testid={`btn-cancel-schedule-${i}`}
                      >{tr('cancel')}</button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Completed/Cancelled */}
          {scheduledList.filter(s => s.status !== 'scheduled').length > 0 && (
            <div className="space-y-3">
              <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wide mt-6">{tr('past_schedules')}</h3>
              {scheduledList.filter(s => s.status !== 'scheduled').map((s, i) => (
                <div key={s.schedule_id || i} className={`bg-white rounded-xl border p-4 ${s.status === 'sent' ? 'border-green-200' : s.status === 'cancelled' ? 'border-slate-200 opacity-60' : 'border-red-200'}`} data-testid={`past-schedule-${i}`}>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-medium text-slate-800 text-sm">{s.newsletter_title || s.subject}</p>
                      <div className="flex items-center gap-2 text-xs text-slate-400 mt-1">
                        <span>{new Date(s.scheduled_at).toLocaleString(locale)}</span>
                        <span className={`px-2 py-0.5 rounded-full font-medium ${s.status === 'sent' ? 'bg-green-100 text-green-700' : s.status === 'cancelled' ? 'bg-slate-100 text-slate-500' : 'bg-red-100 text-red-700'}`}>
                          {s.status === 'sent' ? `${tr('c_sent')} (${s.sent_count || 0})` : s.status === 'cancelled' ? tr('cancelled') : tr('error_word')}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {scheduledList.length === 0 && (
            <div className="bg-white rounded-2xl border border-slate-200 p-12 text-center shadow-sm" data-testid="no-scheduled">
              <span className="text-5xl block mb-3">&#128337;</span>
              <p className="text-slate-500 font-medium">{tr('no_scheduled')}</p>
              <p className="text-sm text-slate-400 mt-1">{tr('no_scheduled_sub')}</p>
              <button onClick={() => setTab('create')} className="mt-4 px-4 py-2 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition">{tr('create_nl')}</button>
            </div>
          )}
        </div>
      )}

      {/* HISTORY TAB */}
      {tab === 'history' && (
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-testid="history-tab">
          <div className="p-4 border-b border-slate-100">
            <h2 className="font-bold text-slate-900" style={{fontFamily:'Outfit'}}>{tr('saved_nl')}</h2>
          </div>
          {newsletters.length === 0 ? (
            <div className="p-12 text-center text-slate-400">{tr('no_nl')}</div>
          ) : (
            <div className="divide-y divide-slate-100">
              {newsletters.map((nl, idx) => (
                <div key={idx} className="p-4 flex items-center justify-between hover:bg-slate-50 transition" data-testid={`newsletter-item-${idx}`}>
                  <div>
                    <p className="font-medium text-slate-900">{nl.title}</p>
                    <div className="flex items-center gap-3 text-xs text-slate-400 mt-1">
                      <span>{nl.template_type}</span>
                      <span>{nl.status === 'sent' ? `✅ ${tr('c_sent')} (${nl.sent_count})` : tr('draft')}</span>
                      <span>{new Date(nl.created_at).toLocaleDateString(locale)}</span>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button onClick={() => loadNewsletter(nl.newsletter_id || '')} className="px-3 py-1.5 bg-slate-100 text-slate-700 rounded-lg text-sm hover:bg-slate-200 transition">{tr('open')}</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* SUBSCRIBERS TAB */}
      {tab === 'subscribers' && (
        <div className="space-y-4" data-testid="subscribers-tab">
          <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
            <h2 className="font-bold text-slate-900 mb-4" style={{fontFamily:'Outfit'}}>{tr('add_subscriber')}</h2>
            <div className="flex flex-wrap gap-3">
              <input value={newSubName} onChange={e => setNewSubName(e.target.value)} placeholder={tr('name')} className="border border-slate-300 rounded-xl px-4 py-2.5 focus:outline-none focus:border-orange-500" data-testid="input-sub-name" />
              <input value={newSubEmail} onChange={e => setNewSubEmail(e.target.value)} placeholder={tr('email')} className="flex-1 min-w-[200px] border border-slate-300 rounded-xl px-4 py-2.5 focus:outline-none focus:border-orange-500" data-testid="input-sub-email" />
              <select value={newSubCategory} onChange={e => setNewSubCategory(e.target.value)} className="border border-slate-300 rounded-xl px-3 py-2.5" data-testid="select-sub-category">
                <option value="parent">{tr('cat_parent')}</option>
                <option value="teacher">{tr('cat_teacher')}</option>
                <option value="admin">{tr('cat_admin')}</option>
                <option value="student">{tr('cat_student')}</option>
              </select>
              <button onClick={addSubscriber} className="px-5 py-2.5 bg-orange-500 text-white rounded-xl font-medium hover:bg-orange-600 transition" data-testid="btn-add-sub">{tr('add')}</button>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
            <div className="p-4 border-b border-slate-100 flex items-center justify-between">
              <h2 className="font-bold text-slate-900" style={{fontFamily:'Outfit'}}>{tr('tab_subscribers')} ({subscribers.length})</h2>
            </div>
            {subscribers.length === 0 ? (
              <div className="p-12 text-center text-slate-400">{tr('no_subs')}</div>
            ) : (
              <div className="divide-y divide-slate-100">
                {subscribers.map((sub, idx) => (
                  <div key={idx} className="p-3 px-4 flex items-center justify-between hover:bg-slate-50" data-testid={`subscriber-${idx}`}>
                    <div>
                      <span className="font-medium text-slate-900 text-sm">{sub.name || sub.email}</span>
                      <span className="text-slate-400 text-xs ml-2">{sub.email}</span>
                      <span className="text-xs bg-slate-100 text-slate-500 px-2 py-0.5 rounded ml-2">{sub.category}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
